import React, { useEffect, useState } from "react";
import styles from "./singleParticipantList.module.scss";
import { Select } from 'antd';
//import taskimg2 from "../../../styles/images/task2.svg";
import taskimg2 from "../../../../styles/images/task2.svg";
import _ from 'lodash';
import { useSelector } from "react-redux";
import { callMainPageInterface } from "../../../../models/callModel";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { searchHandler, searchHighlight, userStatusColor } from "../../../../base/callService/common";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";

type SingleParticipantListProps = {
  alternativeHost?: (val: any, obj:any) => void
  alternateHostModalOpenClose?: any;
  participantSipDetails?: any;
  alternateHostDetails?:any
};

type SingleParticipantListState = {
  allContacts: Array<any>; 
  selectedContacts: any;
  searchKey: string;
  alternateHost: any;
  filteredContacts: any;
  favContactList: Array<any>;
  filteredFavContacts: Array<any>;
};

export default function SingleParticipantList({ alternativeHost, alternateHostModalOpenClose, participantSipDetails, alternateHostDetails }: SingleParticipantListProps) {
  const { contactReducer }: callMainPageInterface = useSelector((state: callMainPageInterface) => state);
  let { workContacts,favContacts } = contactReducer;
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { detailPage, currentWindowState } = meetingReducer;
  const [getData, setData] = useState<SingleParticipantListState>
    ({ allContacts:workContacts,selectedContacts:[],searchKey:'',alternateHost: [], filteredContacts:workContacts,favContactList:[],filteredFavContacts:[],contactSelect:false });
  let resContact: any = searchHandler(workContacts, getData.searchKey);
  let len = Math.ceil((resContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
   let favList: Array<any> = _.filter(favContacts,((contacts:any)=>{
    return !Object.keys(contacts).some(key => key === 'team_id_prefix');
    })); 
  useEffect(() => {
    if (alternateHostModalOpenClose === "closemodal") {
       getData.alternateHost.splice(0, 1);
       setData({ ...getData, alternateHost:getData.alternateHost})
    }
    if(currentWindowState === "meetingDetails" || currentWindowState === "editMeeting")
    {
      let filterdList: any = workContacts; let objectList: any = []; let filtered_favs: any = favList;
      objectList = detailPage.participants.map((elem: any) => {
        if(elem.roletype !== 2)
        return parseInt(elem.sipid);
      });
      filterdList = _.filter(filterdList, function (o: any) {
        return !objectList.includes(o.sip_login_id);
      });

        filtered_favs=_.filter(favList,function (o: any) {
        return !objectList.includes(o.sip_login_id);
      })
      setData({ ...getData, allContacts: filterdList, filteredContacts: filterdList,favContactList:filtered_favs })
    }
    if (participantSipDetails){
      let filterdList: any = workContacts; let filtered_favs: any;
        filterdList = _.filter(filterdList, function (o: any) {
          return !participantSipDetails.includes(o.sip_login_id);
        });

        filtered_favs=_.filter(favList,function (o: any) {
        return !participantSipDetails.includes(o.sip_login_id);
      })
      setData({...getData,allContacts:filterdList,filteredContacts:filterdList,favContactList:filtered_favs,filteredFavContacts:filtered_favs})}
    else {
  //      let filterdList: any = workContacts;
  //  setData({...getData,allContacts:filterdList})
   }
    if (currentWindowState === "editMeeting" || currentWindowState === "reschedule" || currentWindowState === "useTemplate") {
      let existingAlternateHostValue = _.find(detailPage.participants, function (o) { return o.roletype === 2; });
      if (existingAlternateHostValue) {
        getData.alternateHost = [];
        getData.alternateHost.push(parseInt(existingAlternateHostValue.sipid))
        setData({ ...getData, alternateHost: getData.alternateHost })
      }}
    return () => {
    setData({ ...getData,alternateHost:[]}); 
  };
  }, [participantSipDetails,alternateHostModalOpenClose,JSON.stringify(detailPage),currentWindowState])

  useEffect(() => {
  
    if (currentWindowState === "editMeeting" || currentWindowState === "reschedule" || currentWindowState === "useTemplate") {
      let filterdList: any = workContacts; let objectList: any = []; let filtered_favs: any = favList;
      objectList = participantSipDetails.map((elem: any) => {
       
        return parseInt(elem);
      });
      filterdList = _.filter(filterdList, function (o: any) {
        return !objectList.includes(o.sip_login_id);
      });

      filtered_favs=_.filter(favList,function (o: any) {
        return !objectList.includes(o.sip_login_id);
      })
      let a_details = alternateHostDetails

      setData({ ...getData, allContacts: filterdList, filteredContacts: filterdList, alternateHost: a_details,favContactList:filtered_favs,filteredFavContacts:filtered_favs })
    }
  }, [getData.alternateHost]);

  const searchContact = (e:string) => {
    let searchName = e.toLowerCase();
    if(searchName !== "") {
      let filtered = _.filter(getData.filteredContacts, function(name:any) {
        return  name.caller_id?.toLowerCase().includes(searchName) ||
        name.ext?.toString().includes(searchName) ||  name.team_name?.includes(searchName)|| name.email_id?.toLowerCase().includes(searchName);
      });
      let filter_fav = _.filter(getData.favContactList, function (name:any) {
                return  name.caller_id?.toLowerCase().includes(searchName) ||
        name.ext?.toString().includes(searchName) ||  name.team_name?.includes(searchName)|| name.email_id?.toLowerCase().includes(searchName);
      })
      setData({ ...getData, allContacts: filtered, searchKey:searchName,favContactList:filter_fav });
    }
    else {
      setData({...getData,allContacts: getData.filteredContacts, searchKey:searchName,favContactList:getData.filteredFavContacts });
    }
  };

  const contactFocus=()=>{
     setData({...getData,allContacts: getData.filteredContacts, searchKey:"" });
  }

  const selectBoxOnchange = (val: any, obj: any) => {
    if (val.length > 1 || obj.length > 1) {
      val.shift();
      obj.shift();
      setData({...getData,alternateHost:val,allContacts:getData.filteredContacts,searchKey:""})
      alternativeHost(val,obj);
    }
    else {
      setData({ ...getData, alternateHost: val, allContacts: getData.filteredContacts, searchKey: "",contactSelect:false })
       alternativeHost(val,obj);
    }
  };

  const selectDropDown = (e:any) =>{
   

    let element: HTMLElement | any = document.getElementById("meetSchedule") || null;

    if (element != null)  {
      if(element.hasAttribute('scroll') === true){
        element.removeAttribute("scroll");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if(hoverdiv)hoverdiv.style["display"] = "none";
        element.style["overflow-y"] = "overlay";

      }
      else{
        element.setAttribute("scroll", "no");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if(hoverdiv)hoverdiv.style["display"] = "block";

        element.style["overflow"] = "hidden";
      }
    };

  };

  return (
    <>
      {/*<div className={styles.insideicon}>
        <img src={taskimg2} alt="" />
        <Select
          style={{ width: '100%' }}
          placeholder="Search name or extension"
          className="newselects"
          dropdownClassName="newChatSel"
          showSearch={true}
          filterOption={false}
          onChange={selectBoxOnchange}
          onSearch={searchContact}>
          {getData.allContacts?.map((contactName: any, index: any) => {
            let highlighted: any = searchHighlight(contactName, getData.searchKey);     
            return  <option key={index} value={JSON.stringify(contactName)}>
            <div className="dropdowndesign">
              <div className="usergroupss">
                <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`}
                  profileInfo={
                    (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                      (<>
                        <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                        <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                      (<>
                        <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                      </>)
                  } />
              </div>
              {getData.searchKey !== '' ?
                <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                  <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                  {highlighted?.lastMsg}</>) : 
                  (<>{contactName?.caller_id}</>)}</div> :
                <div className="names">{contactName.caller_id}</div>}
              <div className="ext">{contactName.ext}</div>
            </div>
          </option>;
          })}
        </Select>
      </div>*/}


            <div className={styles.insideicon}>
              {getData.alternateHost.length === 0 && <img src={taskimg2} alt="" />}
              <Select
                 mode='multiple'
                 style={{ width: '100%' }}
                 placeholder="Search by name/Enter email ID"
                    className={getData.alternateHost.length === 0 ? "newselects taskcreations customdropbox ":"newselects taskcreations customdropbox inputselectlftnone"}
                 dropdownClassName="newChatSel meetingdropdown"
                filterOption={false}
                showSearch={true}
                onChange={selectBoxOnchange}
                onSearch={searchContact}
          value={getData.alternateHost}
          onDropdownVisibleChange={selectDropDown}
          onFocus={contactFocus}
        >
                               { (getData.favContactList?.length > 0 &&getData.searchKey==='') && 
          <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {getData.favContactList?.map((favcontactName: any, index: any) => {
               
            return  <div key={index} value={favcontactName.sip_login_id}>
        
              <div className="dropdowndesign">
                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                  profileInfo={
                    (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                      (<>
                        <img src={favcontactName.ImageURL} alt="" />
                        <URStatusDot className={ userStatusColor(favcontactName.user_status,'small')}/></>) :
                      (<>
                        <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                        <URStatusDot className={ userStatusColor(favcontactName.user_status,'small')} />
                      </>)
                  } />
                <div className="names">{favcontactName.caller_id}</div>
                <div className="ext">{favcontactName.ext }</div>
              </div>
            </div>;
          })} 
                {getData.allContacts?.map((contactName: any, index: any) => {
                  let highlighted: any = searchHighlight(contactName, getData.searchKey);
                  return <option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
                                       {
                ((getData.allContacts[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
              }
                    <div className="dropdowndesign">
                      <div className="usergroupss">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                              (<>
                                <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                              </>)
                          } />
                      </div>
                      {getData.searchKey !== '' ?
                        <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                          <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                          {highlighted?.lastMsg}</>) : 
                          (<>{contactName?.caller_id}</>)}</div> :
                        <div className="names">{contactName.caller_id}</div>}
                      <div className="ext">{contactName.ext}</div>
                    </div>
                  </option>;
                })}
              </Select>
            </div>
    </>
  );
}
